var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.page.type === 'register')?_c('pp-stepper-register',{attrs:{"page":_vm.page.name}}):(_vm.page.type === 'questionnaire')?_c('pp-stepper-questionnaire',{attrs:{"page":_vm.page.name}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }